import { LOCAL_STORAGE_KEYS } from "e3-common/constants/enumerates";

/**
 * Local Storage에 저장되어 있는 자식 공통코드 목록 가져오는 함수
 * @param {*} parentCodeId 부모코드ID
 * @returns
 */
export const getChildrenCommonCode = async (parentCodeId = "") => {
  const commonCodes = await JSON.parse(
    window.localStorage.getItem(LOCAL_STORAGE_KEYS.COMMON_CODES)
  );
  if (commonCodes?.length > 0) {
    return commonCodes
      .find((f) => f.codeId === parentCodeId)
      ?.children.sort((a, b) => a.ord - b.ord);
  }
  return null;
};

/**
 * Local Storage에 저장되어 있는 자식 공통코드 목록 가져오는 함수 (await 없이 바로)
 * Grid 의 comboBox setting 시 사용
 * @param {*} parentCodeId 부모코드ID
 * @returns
 */
export const getDirectCommonCode = (parentCodeId = "", isBlank = false) => {
  const commonCodes = JSON.parse(
    window.localStorage.getItem(LOCAL_STORAGE_KEYS.COMMON_CODES)
  );
  if (commonCodes?.length > 0) {
    let tmp = {};
    const rtnList = commonCodes
      .find((f) => f.codeId === parentCodeId)
      ?.children.sort((a, b) => a.ord - b.ord);

    if (isBlank) {
      for (let x in commonCodes[0]) {
        tmp = {
          ...tmp,
          [x]: "\u00a0",
        };
      }
    }
    const tmpLenth = Object.keys(tmp).length;

    return tmpLenth > 0 ? [tmp, ...rtnList] : rtnList;
  }
  return null;
};

/**
 * Local Storage에 저장되어 있는 공통코드 가져오는 함수
 * @param {*} parentCodeId 부모코드ID
 * @param {*} codeId 코드ID
 * @returns
 */
export const getCommonCodeById = async (parentCodeId = "", codeId = "") => {
  const children = await getChildrenCommonCode(parentCodeId);

  if (children?.length > 0) {
    return children.find((f) => f.codeId === codeId);
  }
  return null;
};

/**
 * Local Storage에 저장되어 있는 공통코드 가져오는 함수 (await 없이 바로)
 * @param {*} parentCodeId 부모코드ID
 * @param {*} codeId 코드ID
 * @returns
 */
export const getDirectCommonCodeById = (parentCodeId = "", codeId = "") => {
  const children = getDirectCommonCode(parentCodeId);

  if (children?.length > 0) {
    return children.find((f) => f.codeId === codeId);
  }
  return null;
};

/**
 * 파라미터가 배열인지 아닌지 체크
 * 배열: true
 * 그외: false
 * @param {*} arr
 * @returns
 */
export const chkArray = (arr) => {
  if (arr && arr.length > 0) {
    return true;
  } else {
    return false;
  }
};
